import React from 'react';
import { Check } from 'lucide-react';

const WeeklyReportSection = () => {
  const benefits = [
    'Personalized to your actual data',
    'Sent via push notification + email',
    "Actionable focus from Vera every week",
  ];

  return (
    <section
      data-testid="weekly-report-section"
      className="bg-[#FAFAF7] section-padding"
    >
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p
            data-testid="report-section-label"
            className="font-body text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-[#95B8A2] mb-4"
          >
            Every Monday Morning
          </p>
          <h2
            data-testid="report-section-headline"
            className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2D2D2D] leading-tight"
          >
            Your Personal Financial
            <br />
            Report Card — Delivered Weekly.
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center max-w-6xl mx-auto">
          {/* Left Side - Report Mockup */}
          <div className="w-full lg:w-1/2">
            <div
              data-testid="weekly-report-mockup"
              className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-[#1B4332]/5 max-w-md mx-auto lg:mx-0"
            >
              {/* Report Header */}
              <div className="bg-[#1B4332] py-6 px-6">
                <div className="border-t-2 border-b-2 border-[#D4AF37]/50 py-3">
                  <p className="font-heading text-lg font-bold text-[#FAFAF7] text-center tracking-wide">
                    FINDELL WEEKLY REPORT
                  </p>
                  <p className="font-body text-sm text-[#95B8A2] text-center mt-1">
                    Week of April 7-13, 2026
                  </p>
                </div>
              </div>

              {/* Report Content */}
              <div className="p-6 space-y-6">
                {/* Financial Health Score */}
                <div className="text-center pb-4 border-b border-[#1B4332]/10">
                  <p className="font-body text-xs text-[#2D2D2D]/60 uppercase tracking-wider mb-2">
                    Financial Health
                  </p>
                  <div className="flex items-end justify-center gap-2">
                    <span className="font-mono text-5xl font-bold text-[#1B4332]">74</span>
                    <span className="font-mono text-lg font-semibold text-[#2ECC71] pb-2">↑3 points</span>
                  </div>
                </div>

                {/* Wins Section */}
                <div>
                  <p className="font-body text-sm font-semibold text-[#2ECC71] mb-3 flex items-center gap-2">
                    💚 WINS THIS WEEK
                  </p>
                  <ul className="space-y-2">
                    <li className="font-body text-sm text-[#2D2D2D]/80 flex items-start gap-2">
                      <span className="text-[#2ECC71]">•</span>
                      Under food budget 5/7 days
                    </li>
                    <li className="font-body text-sm text-[#2D2D2D]/80 flex items-start gap-2">
                      <span className="text-[#2ECC71]">•</span>
                      Saved $47 toward vacation
                    </li>
                    <li className="font-body text-sm text-[#2D2D2D]/80 flex items-start gap-2">
                      <span className="text-[#2ECC71]">•</span>
                      Completed "Emergency Fund" lesson
                    </li>
                  </ul>
                </div>

                {/* Vera's Focus */}
                <div className="bg-[#F39C12]/10 rounded-xl p-4">
                  <p className="font-body text-sm font-semibold text-[#F39C12] mb-2 flex items-center gap-2">
                    ⚡ VERA'S FOCUS
                  </p>
                  <p className="font-body text-sm text-[#2D2D2D]/80">
                    Subscriptions: <span className="font-mono font-semibold">$187/month</span>
                  </p>
                  <p className="font-body text-sm text-[#2D2D2D]/70 mt-1">
                    Let's find $30 to cut Tuesday.
                  </p>
                </div>

                {/* Numbers Section */}
                <div>
                  <p className="font-body text-sm font-semibold text-[#1B4332] mb-3 flex items-center gap-2">
                    📊 YOUR NUMBERS
                  </p>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <p className="font-body text-xs text-[#2D2D2D]/60">Income</p>
                      <p className="font-mono text-lg font-bold text-[#1B4332]">$2,840</p>
                    </div>
                    <div>
                      <p className="font-body text-xs text-[#2D2D2D]/60">Spent</p>
                      <p className="font-mono text-lg font-bold text-[#2D2D2D]">$1,920</p>
                    </div>
                    <div>
                      <p className="font-body text-xs text-[#2D2D2D]/60">Saved</p>
                      <p className="font-mono text-lg font-bold text-[#2ECC71]">$920</p>
                      <p className="font-body text-xs text-[#2ECC71]">(32% rate)</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Benefits */}
          <div className="w-full lg:w-1/2 space-y-8">
            {benefits.map((benefit, index) => (
              <div
                key={benefit}
                data-testid={`report-benefit-${index}`}
                className="flex items-start gap-4 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-10 h-10 bg-[#1B4332] rounded-full flex items-center justify-center flex-shrink-0">
                  <Check className="w-5 h-5 text-white" />
                </div>
                <p className="font-body text-lg text-[#2D2D2D] pt-2">
                  {benefit}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WeeklyReportSection;
